export const GET_USER_INTERVIEWS = 'USER_INTERVIEWS/GET_USER_INTERVIEWS'
export const GET_USER_INTERVIEWS_SUCCESS = 'USER_INTERVIEWS/GET_USER_INTERVIEWS_SUCCESS'
export const GET_USER_INTERVIEWS_FAILURE = 'USER_INTERVIEWS/GET_USER_INTERVIEWS_FAILURE'

export interface IGetUserInterviewsAction {
  type: typeof GET_USER_INTERVIEWS
  payload: {}
}

export interface IGetUserInterviewsSuccessAction {
  type: typeof GET_USER_INTERVIEWS_SUCCESS
  payload: {
    regular_interviews: any[]
    ava_interviews: any[]
  }
}

export interface IGetUserInterviewsFailureAction {
  type: typeof GET_USER_INTERVIEWS_FAILURE
  payload: {
    error: string
  }
}

export type UserInterviewsActionTypes =
  | IGetUserInterviewsAction
  | IGetUserInterviewsSuccessAction
  | IGetUserInterviewsFailureAction


